module.exports = __webpack_public_path__ + "img/227-b2e901.png";